import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  linkStyle: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  linkIcon: {
    transform: 'rotate(135deg)',
    marginRight: theme.spacing(0.5)
  }
}));